import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import {fetchMembershipHistory} from '../redux/actions';
import {userSelector, chapterSelector, rankSelector, authSelector, chapterMemberSelector} from '../redux/selectors';
import { toArray } from '../common/util';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import {hasGroup} from "../common/permissions";

const localizer = momentLocalizer(moment)

class Dashboard extends Component {
    componentDidMount() {
        document.title = "Addiction | Dashboard";
        //this.props.getMembership();
    }

    dateDiffInDays = (a, b) => {
        let _MS_PER_DAY = 1000 * 60 * 60 * 24;
        // Discard the time and time-zone information.
        let utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
        let utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

        return Math.floor((utc2 - utc1) / _MS_PER_DAY);
    };

    buildProgress = (chapter, chapterMembers) => {
        if (toArray(chapterMembers.data).length > 0) {
            let memberRecords = toArray(chapterMembers.data)
                .filter(member => member.member === Number(this.props.auth.currentUser.id))
                .filter(member => member.chapter === chapter.id)
                .sort((a, b) => (new Date(b.openDate).getTime() - new Date(a.openDate).getTime()));
            let totalDuration = null;

            if (chapter.closeDate) {
                totalDuration = this.dateDiffInDays(new Date(chapter.openDate), new Date(chapter.closeDate))
            } else {
                totalDuration = this.dateDiffInDays(new Date(chapter.openDate), new Date())
            }



            let preJoinPreLaunch = this.dateDiffInDays(new Date(chapter.openDate), new Date(memberRecords[0].joinDate));
            let preJoinPreLaunchP = preJoinPreLaunch / totalDuration * 100;
            if (preJoinPreLaunchP > 100) {
                preJoinPreLaunchP = 100;
            }
            if (preJoinPreLaunchP < 0) {
                preJoinPreLaunchP = 0;
            }

            let postJoinPreLaunch = this.dateDiffInDays(new Date(memberRecords[0].joinDate), new Date(chapter.launchDate));
            if (postJoinPreLaunch < 0) {
                postJoinPreLaunch = 0;
            }

            let postJoinPreLaunchP = postJoinPreLaunch / (totalDuration+postJoinPreLaunch) * 100;//TODO hacko and openDate should be properly calculated in the import script
            if (postJoinPreLaunchP > 100) {
                postJoinPreLaunchP = 100
            }
            if (postJoinPreLaunchP < 0) {
                postJoinPreLaunchP = 0
            }

            totalDuration = postJoinPreLaunch + totalDuration; //TODO hacko and openDate should be properly calculated in the import script

            let preJoinPostLaunch = this.dateDiffInDays(new Date(chapter.launchDate), new Date(memberRecords[0].joinDate));
            if (preJoinPostLaunch < 0) {
                preJoinPostLaunch = 0;
            }
            let preJoinPostLaunchP = preJoinPostLaunch / totalDuration * 100;
            if (preJoinPostLaunchP > 100) {
                preJoinPostLaunchP = 100
            }
            if (preJoinPostLaunchP < 0) {
                preJoinPostLaunchP = 0
            }

            // temporary fix for open and launch being identical
            if (preJoinPreLaunchP === preJoinPostLaunchP) {
                preJoinPreLaunchP = 0;
            }
            // Determine if join date is before or after launch - if before then use launchdate for this section of the bar
            let joinDate = null;
            if (new Date(memberRecords[0].joinDate) < new Date(chapter.launchDate)) {
                joinDate = new Date(chapter.launchDate)
            } else {
                joinDate = new Date(memberRecords[0].joinDate)
            }

            // Extend multiple joins and leaves from first start to last finish
            let quitDate = null;
            //if there is more than one record set quitdate to that leave date, or set to now
            if (memberRecords.slice(0, -1).length > 0) {
                if (memberRecords.slice(0, -1).leaveDate !== null) {
                    quitDate = new Date(memberRecords.slice(0, -1).leaveDate)
                } else { quitDate = new Date() }
            } else {
                // set quitdate to leave date, or set to now
                if (memberRecords[0].leaveDate !== null) {
                    quitDate = new Date(memberRecords[0].leaveDate)
                } else { quitDate = new Date() }
            }
            // if chapter is closed and leave date is after close date then clamp at close date
            if (chapter.closeDate !== null) {
                if (quitDate > new Date(chapter.closeDate)) {
                    quitDate = new Date(chapter.closeDate);
                }
            }
            console.log(chapter.game.title)
            console.log(quitDate)


            let postJoinPostLaunch = this.dateDiffInDays(joinDate, quitDate);
            let postJoinPostLaunchP = postJoinPostLaunch / totalDuration * 100;
            if (postJoinPostLaunchP > 100) {
                postJoinPostLaunchP = 100;
            }
            let endDate = new Date(chapter.closeDate);
            if (!chapter.closeDate) {
                endDate = new Date()
            }

            let postJoinPreClose = this.dateDiffInDays(quitDate, endDate);
            let postJoinPreCloseP = postJoinPreClose / totalDuration * 100;
            if (postJoinPreCloseP > 100) {
                postJoinPreCloseP = 100;
            }

            return (
                <div className="progress">
                    <OverlayTrigger placement="top" overlay={<Tooltip id="created-tooltip">preJoinPreLaunchP</Tooltip>}>
                        <div className="progress-bar" style={{backgroundColor: "grey", width: preJoinPreLaunchP+"%"}}>{preJoinPreLaunchP}</div>
                    </OverlayTrigger>
                    <OverlayTrigger placement="top" overlay={<Tooltip id="created-tooltip">postJoinPreLaunch</Tooltip>}>
                        <div className="progress-bar" style={{backgroundColor: "yellow", width: postJoinPreLaunchP+"%"}}>{postJoinPreLaunchP}</div>
                    </OverlayTrigger>
                    <OverlayTrigger placement="top" overlay={<Tooltip id="created-tooltip">preJoinPostLaunch</Tooltip>}>
                        <div className="progress-bar" style={{backgroundColor: "grey", width: preJoinPostLaunchP+"%"}}>{preJoinPostLaunchP}</div>
                    </OverlayTrigger>
                    <OverlayTrigger placement="top" overlay={<Tooltip id="created-tooltip">postJoinPostLaunch</Tooltip>}>
                        <div className="progress-bar" style={{backgroundColor: "green", width: postJoinPostLaunchP+"%"}}>{postJoinPostLaunchP}</div>
                    </OverlayTrigger>
                    <OverlayTrigger placement="top" overlay={<Tooltip id="created-tooltip">postJoinPreClose</Tooltip>}>
                        <div className="progress-bar" style={{backgroundColor: "grey", width: postJoinPreCloseP+"%"}}>{postJoinPreCloseP}</div>
                    </OverlayTrigger>
                </div>
            )
        }

    };

    EventAgenda = ({ event }) => {
        return (
            <span>
                <strong>{event.title}</strong>
                <p>{event.desc}</p>
            </span>
        )
    };

    render() {
        if (hasGroup('Member',this.props.auth.groups)) {
            return (
                <div>
                    <h1>Dashboard</h1>
                    <Row>
                        <Col md={8}>
                            <div className="panel-adt" style={{minHeight:"400px"}}>
                                <h2>Upcoming Events</h2>
                                <Calendar
                                    localizer={localizer}
                                    defaultDate={new Date()}
                                    defaultView="agenda"
                                    views={['agenda']}
                                    style={{height:"92.5%"}}
                                    components={{
                                        agenda: {
                                            event: this.EventAgenda,
                                        }
                                    }}
                                    events={[]}
                                    // events={[{
                                    //     id: 14,
                                    //     title: 'World of Warcraft Raid Night',
                                    //     start: new Date(new Date().setHours(new Date().getHours() - 3)),
                                    //     end: new Date(new Date().setHours(new Date().getHours() + 3)),
                                    //     desc: 'DESCRIPTION ME',
                                    // }]}
                                />
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="panel-adt" style={{height:"400px"}}>
                                <h2>Calendar</h2>
                                <Calendar
                                    localizer={localizer}
                                    defaultDate={new Date()}
                                    defaultView="month"
                                    views={['month']}
                                    style={{height:"92.5%"}}
                                    events={[]}
                                    // events={[{
                                    //     id: 14,
                                    //     title: 'World of Warcraft Raid Night',
                                    //     start: new Date(new Date().setHours(new Date().getHours() - 3)),
                                    //     end: new Date(new Date().setHours(new Date().getHours() + 3)),
                                    //     desc: 'DESCRIPTION ME',
                                    // }]}
                                />
                            </div>
                        </Col>
                    </Row>
                    {/*
                    <Row>
                        <Col md={6}>
                            <div className="panel-adt">
                                <h2>Active Chapter Membership</h2>
                            </div>
                                {toArray(this.props.chapterMembers.data).length > 0 ?
                                toArray(this.props.chapters)
                                    .filter(chapter => toArray(this.props.chapterMembers.data).filter(member => member.member === this.props.auth.currentUser.id).some(member => member.chapter === chapter.id))
                                    .filter(chapter => toArray(this.props.chapterMembers.data).filter(member => member.member === this.props.auth.currentUser.id).some(member => member.chapter === chapter.id && member.leaveDate === null))
                                    .sort((a, b) => (new Date(b.openDate).getTime() - new Date(a.openDate).getTime()))
                                    .map((chapter, i) => (
                                <div key={i} className="panel-adt">
                                    <h3>{this.props.chapters[chapter.id].game.title}</h3>
                                    {this.buildProgress(chapter, this.props.chapterMembers)}
                                    <h4>Section Lifetime: </h4>
                                </div>
                            )):('')}
                        </Col>
                        <Col md={6}>
                            <div className="panel-adt">
                                <h2>Chapter Membership History</h2>
                            </div>
                            {toArray(this.props.chapterMembers.data).length > 0 ?
                                toArray(this.props.chapters)
                                    .filter(chapter => toArray(this.props.chapterMembers.data).filter(member => member.member === this.props.auth.currentUser.id).some(member => member.chapter === chapter.id))
                                    .filter(chapter => toArray(this.props.chapterMembers.data).filter(member => member.member === this.props.auth.currentUser.id).some(member => member.chapter === chapter.id && member.leaveDate !== null))
                                    .sort((a, b) => (new Date(b.openDate).getTime() - new Date(a.openDate).getTime()))
                                    .map((chapter, i) => (
                                <div key={i} className="panel-adt">
                                    <h3>{this.props.chapters[chapter.id].game.title}</h3>
                                    {this.buildProgress(chapter, this.props.chapterMembers)}
                                    <h4>Section Lifetime: </h4>
                                </div>
                            )):('')}
                        </Col>
                    </Row>*/}
                </div>
            )
        } else {
            return (
                <Redirect to="/" />
            )
        }

    }
}

const mapStateToProps = (state) => ({
    auth: authSelector(state),
    ranks: rankSelector(state),
    users: userSelector(state),
    chapters: chapterSelector(state),
    chapterMembers: chapterMemberSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    getMembership: () => dispatch(fetchMembershipHistory()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);


// WEBPACK FOOTER //
// ./src/Dashboard/Dashboard.js